import React, { useEffect, useState } from 'react';
import { Amplify } from 'aws-amplify';
import { getCurrentUser, signInWithRedirect, signOut } from 'aws-amplify/auth';
import { awsConfig } from './aws-config';
import HomePage from './components/HomePage';
import './App.css';
import './components/mobile-charts.css';



Amplify.configure(awsConfig);

function App() {
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkUser();
  }, []);

  const checkUser = async () => {
    try {
      const currentUser = await getCurrentUser();
      setUser(currentUser);
    } catch (error) {
      setUser(null);
    }
    setLoading(false);
  };

  const handleSignIn = () => {
    signInWithRedirect();
  };

  const handleSignOut = async () => {
    await signOut();
    setUser(null);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return (
      <div className="App">
        <div className="auth-container">
          <h1 className="welcome-title">LLM Development Console</h1>
          <p className="welcome-subtitle">Sign in to build, test, and deploy your LLM applications</p>
          <button className="auth-button" onClick={handleSignIn}>
            Sign In with Cognito
          </button>
        </div>
      </div>
    );
  }

  return (
    <div>
      <nav className="top-nav">
        <span className="user-info">Welcome, {user.username}</span>
        <button className="sign-out-btn" onClick={handleSignOut}>
          Sign Out
        </button>
      </nav>
      <HomePage />
    </div>
  );
}

export default App;
